import { createFileRoute } from '@tanstack/react-router';

import { DidMappingListScreen } from '@/features/telephony/components/DidMappingListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/telephony/did-mappings')({
  beforeLoad: () => {
    requirePermission('did_mapping:read');
  },
  // Workspace surface: BA super admins manage their own numbers, BA admins
  // only read.
  component: WorkspaceDidMappingsRoute,
  staticData: { crumb: 'Helpline numbers' },
});

function WorkspaceDidMappingsRoute() {
  return <DidMappingListScreen surface="workspace" />;
}
